const ServerRoutes = {
  User: {
    getInviteLink: "users/getInviteLink",
    getAll: "users/getAll",
    getProducerClients: "users/getProducerClients",
    edit: "users/edit/",
    addBS: "users/addProducer/",
    destroyUser: "users/destroyUser/",
    ipus: "users/ipus/",
    getInvitationDetails: "users/getInvitationDetails/",
    getInvitationDetailsSelf: "users/getInvitationDetailsSelf/",
    editDetails: "users/editDetails/",
    incrementFreeSms: "users/incrementFreeSms/",
    deactivateEvent: "users/deactivateEvent/",
    delete: "users/deleteClient",
    getPaymentDetails: "users/getPaymentDetails",
    getPhoneNumber: "users/getPhoneNumber",
  },
  Efrat: {
    getAll: "efrat/getAll",
    edit: "efrat/edit/",
    sendWelcome: "efrat/sendWelcome/",
    send: "efrat/send/",
    cancel: "efrat/cancel/",
    add: "efrat/add/",
    destroyUser: "efrat/destroyUser/",
  },
  Payments: {
    getAll: "payments/getAll/",
    getAllAdmin: "payments/getAllAdmin/",
    createlink: "payments/createlink/",
    setRecord: "payments/setRecord/",
    editBlessing: "payments/editBlessing/",
  },
  Auth: {
    logoutAll: "auth/logoutAll",
    logoutSpecific: "auth/logoutSpecific",
    login: "auth/login",
    registerDIY: "users/registerDIY",
    registerSBS: "users/registerSBS",
    checkAuth: "auth/checkAuth",
  },
  Photos: {
    upload: "photos/upload/",
    uploadAdmin: "photos/uploadAdmin/",
    delete: "photos/delete/",
  },
  Helpers: {
    getAll: "helpers/getAll/",
    delete: "helpers/delete/",
    add: "helpers/add/",
  },
  Todos: {
    getAll: "todos/getAll/",
    getAllAdmin: "todos/getAllAdmin/",
    getAllAvivit: "todos/getAllAvivit/",
    getTalsCalls: "todos/getTalsCalls/",
    getAllProducer: "todos/getAllProducer/",
    delete: "todos/delete/",
    edit: "todos/edit/",
    setSchedule: "todos/setSchedule/",
    setDone: "todos/setDone/",
    setBelogs: "todos/setBelogs/",
    add: "todos/add/",
    editTal: "todos/editTal/",
  },
  Guests: {
    getAll: "guests/getAll/",
    getAllAvivit: "guests/getAllAvivit/",
    getById: "guests/getById/",
    delete: "guests/deleteMany/",
    countNotAnswered: "guests/countNotAnswered/",
    editMany: "guests/editMany/",
    getGuestAdmin: "guests/getGuestAdmin/",
    editArrive: "guests/editArrive/",
    editGift: "guests/editGift/",
    edit: "guests/edit/",
    findByPhones: "guests/findByPhones/",
    seperation: "guests/seperation/",
    seperationEvent: "guests/seperationEvent/",
    editArrival: "guests/editArrival/",
    add: "guests/add/",
    addMany: "guests/addMany/",
    AddG2T: "guests/AddG2T/",
    syncSeatup: "guests/syncSeatup/",
  },
  Sms: {
    send: "sms/send/",
    sendGeneric: "sms/sendGeneric/",
  },
  Whatsapp: {
    send: "whatsapp/send/",
  },
  SmsScheduled: {
    schedule: "scheduled-sms/schedule/",
    date: "scheduled-sms/date/",
    cancelById: "scheduled-sms/cancel-by-id/",
    editById: "scheduled-sms/edit-by-id/",
    deleteOld: "scheduled-sms/delete-old/",
  },
  WhatsappScheduled: {
    send: "whatsapp/send/",
  },
  Records: {
    getTals: "records/getTals/",
    getTTodos: "records/getTTodos/",
    add: "records/add/",
    getByMonth: "records/getByMonth/",
    setCalls: "records/setCalls/",
  },
  Answers: {
    getAll: "answers/getAll/",
    delete: "answers/delete/",
  },
  News: {
    getAll: "news/getAll/",
    delete: "news/delete/",
  },
  Payments: {
    createIBSuser: "payments/createIBSuser/",
    cardcomCreateLinkForUserPayment:
      "payments/cardcomCreateLinkForUserPayment/",
    getCoupleDetails: "payments/getCoupleDetails/",
    delete: "news/delete/",
  },
};

export default ServerRoutes;
